import { Injectable } from "@angular/core";

@Injectable()

export class RolePermissionsService {

    public userPermissionsList: Array<any> = [];

    constructor() {
    }

    setRolePermissions(roles: Array<any> = []) {
        this.userPermissionsList = roles || [];
    }

    //Role Permissions at component level
    public hasPermission(permission: string) {
        let allPermission: string = permission.split('.')[0] + '.*';
        let index: any = this.userPermissionsList.findIndex((item) => item == allPermission);
        if (index >= 0) {
            return true;
        }
        index = this.userPermissionsList.findIndex((item) => item == permission);
        if (index >= 0) {
            return true;
        }
        return false;
    }

    //AuthGuard at route level
    hasPermissionIn(permissions: Array<string>) {
        let allow: boolean = false;

        for (let i = 0; i < permissions.length; i++) {
            if (this.hasPermission(permissions[i])) {
                allow = true;
                break;
            }
        }
        return allow;
    }
}